// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__Qf9j-","name":"ConsentHeader_name__2TE7X","birthday":"ConsentHeader_birthday__22X1H","skeleton":"ConsentHeader_skeleton__5J3sW"};